import {Contact,OptionMenu} from './components';

export function Skeleton(props){

    const {type} = props

    return(
        <>
            {type === 'contact' && <Contact/>}
            {type === 'optionMenu' && <OptionMenu/>}
        </>
    );
}       